import InitFormstackValidation from './formstack-validation.js'

export default class Formstack {
  constructor() {
    this.init()
  }

  init() {
    let _this = this
    var formstackInverval = setInterval(checkFormstack, 500)

    function checkFormstack() {
      console.log('Loading...')
      if ($('.formstack-form input[name=form]').length === 0) return
      const formObjectName = `form${$('.formstack-form input[name=form]').val()}`
      if (typeof window[formObjectName] === 'undefined') return
      if (typeof window[formObjectName].initializing === 'undefined') return
      if (window[formObjectName].initializing === true) return
      return removeFormstackInverval()
    }

    function removeFormstackInverval() {
      clearInterval(formstackInverval)
      init()
    }

    function init() {
      console.log('Finished loading.')
      let formstackForm = $('[id^="fsForm"]')
      let validation = new InitFormstackValidation(formstackForm)
      $("form[class*='fsForm']").addClass('form-reset')
      $("form[class*='fsForm']").prev('style').remove()
      $('.formstack-form').find('style').remove()
      // $('[aria-label*="Name"]').attr('pattern', '[A-Za-z]+')
      _this.setupFormStackFields(formstackForm, validation)
      _this.handleSelect()
      _this.handleTextArea()
      _this.onSelectClick()
      _this.onItemSelect()
      _this.onSubmit(formstackForm)
      _this.handleInput()
    }
  }

  handleInput() {
    $('.form-reset input').each(function () {
      if (
        $(this).attr('placeholder') == '' ||
        $(this).attr('placeholder') == null ||
        $(this).attr('placeholder') == undefined
      ) {
        $(this).attr('placeholder', $(this).next('label').text())
      }
      if ($(this).prev('label').not('.fsOptionLabel').length > 0) {
        $(this).prev('label').not('.fsOptionLabel').insertAfter($(this))
        $(this).attr('placeholder', $(this).next('label').text())
      }
    })
  }

  handleSelect() {
    $('.form-reset select').each(function () {
      $(this).next('label').addBack().wrapAll('<div class="field"></div>')
      $(this).hide()
      $(this).closest('div').addClass('select')
      $(this).find('option[value=""]').hide()
      var placeholder = $(this).attr('aria-label')
      var id = $(this).attr('id')
      var required = ''
      if ($(this).prop('required')) {
        required = 'required'
      }
      $(this).after('<ul></ul>')
      $(this).after(
        '<input id=' +
          id +
          ' ' +
          required +
          ' type="text" name="button" autocomplete="off" readonly="readonly" placeholder=' +
          placeholder +
          ' class="select"><i class="ico ico--f-chevron-d-s ico--sm" aria-hidden="true"></i>'
      )
      $(this)
        .find('option')
        .each(function () {
          var value = "'" + $(this).val() + "'"
          var text = $(this).text()
          if (value == '' || value == null) {
            return
          }
          $(this)
            .closest('div.select')
            .find('ul')
            .append('<li data-value=' + value + ' class="select-item">' + text + '</li>')
        })
    })
    $('.form-reset input').each(function () {
      if ($(this).closest('div').prev('label:not(.fsOptionLabel)').length > 0) {
        $(this).closest('div').prev('label').insertAfter($(this))
      }
      if ($(this).attr('placeholder') == 'undefined') {
        $(this).attr('placeholder', $(this).next('label').text())
        $(this)
          .closest('div.fsCell')
          .find('div.fsSupporting')
          .detach()
          .appendTo($(this).closest('div'))
      }
    })
  }

  handleTextArea() {
    $('textarea').each(function () {
      $(this).nextAll().addBack().wrapAll('<div class="field"></div>')
      if (
        $(this).attr('placeholder') == '' ||
        $(this).attr('placeholder') == null ||
        $(this).attr('placeholder') == undefined
      ) {
        $(this).attr('placeholder', $(this).next('label').text())
      }
      if ($(this).closest('.field').prev('label').length > 0) {
        $(this).closest('.field').prev('label').insertAfter($(this))
        $(this).attr('placeholder', $(this).next('label').text())
      }
      if ($(this).closest('.field').find('div.fsSupporting').length) {
        $(this).closest('div.fsCell').css('margin-bottom', 0)
      }
    })
  }

  onSelectClick() {
    $('input[type=text].select').each(function () {
      $(this).on('click', function () {
        var currSelect = $(this).siblings('ul')
        $('.select ul').not(currSelect).removeClass('is-active')
        $(this).siblings('ul').toggleClass('is-active')
      })
    })
    $(document).on('click', function (e) {
      if (!$(e.target).is('.select *')) {
        $('.select').find('ul').removeClass('is-active')
      }
    })
  }

  onItemSelect() {
    let _this = this
    $('input[type=text].select')
      .siblings('ul')
      .find('li')
      .on('click', function () {
        var value = "'" + $(this).data('value') + "'"
        var text = $(this).text()
        $(this).siblings('li.is-active').removeClass('is-active')
        $(this).addClass('is-active')
        $(this).parent().siblings('input[type=text].select').attr('value', text)
        $(this).parent().removeClass('is-active')
        $(this).parent().siblings('select').val(value)
        $(this)
          .parent()
          .siblings('select')
          .find('option[value=' + value + ']')
          .prop('selected', true)
        _this.handleConditional(
          $(this).closest('form').attr('id'),
          $(this).parent().siblings('select').attr('id')
        )
      })
  }

  handleConditional(formId, selectId) {
    formId = 'form' + formId.match(/\d+/)
    window[formId].checkLogic(document.getElementById(selectId))
  }

  onSubmit(formstackForm) {
    formstackForm.on('submit', function (e) {
      console.log('Submitting...')
      // e.preventDefault()
      let requiredFields = formstackForm.find('input.fsRequired, input:required')
      if (!requiredFields.hasClass('is-error') && requiredFields.val()) {
        $(this).closest('.container').find('h3').first().text('Successfully submitted')
        $(this)
          .closest('form')
          .slideUp('fast', function () {
            $('form', parent.document).height($('body').height() + 5)
          })
          .next('p.success-message')
          .fadeIn()
        console.log('Submittion successful!')
      } else {
        console.log('Submittion unsuccessful')
      }
      // e.preventDefault()
    })
  }

  setupFormStackFields(formstackForm, validation) {
    formstackForm.find('input[type=tel]').each(function () {
      validation.setUpPhoneField($(this))
    })
    formstackForm.after(
      '<p class="success-message" style="display: none;">Thank you for your interest. We will be in touch soon</p>'
    )
  }
}
